import ApiService from '@boServices/apiService';

class PlatformService extends ApiService {
    getPlatforms({ search = '', types = [], clientId = null, page = 1, perPage = 20, signal } = {}) {
        const params = new URLSearchParams({ page: String(page), perPage: String(perPage) });
        if (search) params.set('search', search);
        if (clientId) params.set('clientId', clientId);
        types.forEach((type) => params.append('types[]', type));
        return this.fetchWithHeaders(`/api/v2/backoffice/platforms?${params.toString()}`, 'GET', { signal });
    }

    getPlatform(uuid) {
        return this.fetchWithHeaders(`/api/v2/backoffice/platforms/${uuid}`, 'GET');
    }

    createPlatform(payload) {
        return this.fetchWithHeaders('/api/v2/backoffice/platforms', 'POST', {
            body: JSON.stringify(payload),
        });
    }

    updatePlatform(uuid, payload) {
        return this.fetchWithHeaders(`/api/v2/backoffice/platforms/${uuid}`, 'PUT', {
            body: JSON.stringify(payload),
        });
    }

    getContext(uuid) {
        return this.fetchWithHeaders(`/api/v2/backoffice/platforms/${uuid}/context`, 'GET');
    }

    updateContext(uuid, html) {
        return this.fetchWithHeaders(`/api/v2/backoffice/platforms/${uuid}/context`, 'PUT', {
            body: JSON.stringify({ html }),
        });
    }
}

export default PlatformService;
